import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import OnePageLayout from "../../components/layout/OnePageLayout";
import Btn from "../../styles/images/img_change_toggle_btn.png";
import toAmo from "../../styles/images/img_to_amo.png";
import toPoint from "../../styles/images/img_to_point.png";
import TopPointBanner from "../../components/main/TopPointBanner";
import { returnLoginStatus } from "../../components/hooks/authFunc";

const AmoChange = () => {
  const [toAmoCoin, setToAmoCoin] = useState(true);
  const navigate = useNavigate();
  const isLogin = returnLoginStatus();
  return (
    <OnePageLayout title="AMO 포인트 교환">
      <Section className="nonePaddingTop">
        <div>
          {isLogin && <TopPointBanner />}
          <AmoChangeContent>
            {/* <ChangeWrap>
              <button
                onClick={() => {
                  setToAmoCoin(!toAmoCoin);
                }}
              >
                교환
              </button>
              <ChangeText>
                {toAmoCoin ? (
                  <p>
                    <span className="col">뮤 포인트</span>를
                    <br />
                    <span className="col">AMO 코인</span>으로 교환
                  </p>
                ) : (
                  <p>
                    <span className="col">AMO 코인</span>을
                    <br />
                    <span className="col">뮤 포인트</span>로 교환
                  </p>
                )}
              </ChangeText>
            </ChangeWrap> */}
            <ChangeWrap>
              <ul>
                <li className={toAmoCoin ? "select" : ""}>
                  <input
                    type="radio"
                    id="toAmoCoin"
                    name="changeAmo"
                    checked={toAmoCoin ? true : false}
                    onChange={() => {
                      setToAmoCoin(true);
                    }}
                  />
                  <label htmlFor="toAmoCoin">
                    <p>
                      <span className="col">뮤 포인트</span>를
                      <br />
                      <span className="col">AMO 코인</span>으로
                    </p>
                  </label>
                </li>
                <li className={toAmoCoin ? "" : "select"}>
                  <input
                    type="radio"
                    id="toPoint"
                    name="changeAmo"
                    checked={toAmoCoin ? false : true}
                    onChange={() => {
                      setToAmoCoin(false);
                    }}
                  />
                  <label htmlFor="toPoint">
                    <p>
                      <span className="col">AMO 코인</span>을
                      <br />
                      <span className="col">뮤 포인트</span>로
                    </p>
                  </label>
                </li>
              </ul>
              {/* <button
                onClick={() => {
                  setToAmoCoin(!toAmoCoin);
                }}
              >
                교환
              </button>
              <ChangeText>
                {toAmoCoin ? (
                  <p>
                    <span className="col">뮤 포인트</span>를
                    <br />
                    <span className="col">AMO 코인</span>으로 교환
                  </p>
                ) : (
                  <p>
                    <span className="col">AMO 코인</span>을
                    <br />
                    <span className="col">뮤 포인트</span>로 교환
                  </p>
                )}
              </ChangeText> */}
            </ChangeWrap>
            <ImgWrap margintop="8" imgwidth="18.2">
              <img src={toAmoCoin ? toAmo : toPoint} alt="" />
            </ImgWrap>
          </AmoChangeContent>
        </div>
        <Btns>
          <ButtonL
            onClick={() => {
              navigate("/amo/change/current", {
                state: { toAmoCoin: toAmoCoin },
              });
            }}
          >
            교환하기
          </ButtonL>
        </Btns>
      </Section>
    </OnePageLayout>
  );
};

export default AmoChange;
const AmoChangeContent = styled(Content)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const ChangeWrap = styled.div`
  /* display: flex;
  align-items: flex-start; */
  margin-top: 5rem;
  width: 100%;
  button {
    width: 4.4rem;
    height: 4.4rem;
    font-size: 0;
    margin-right: 1rem;
    background-image: url(${Btn});
    background-position: center;
    background-size: cover;
  }
  ul {
    display: flex;
    justify-content: space-between;
    /* :nth-of-type(2) {
      margin-top: 2rem;
    } */
  }
  li {
    /* display: flex; */
    width: calc(50% - 0.5rem);
    padding: 1.5rem;
    background-color: #fff;
    color: ${({ theme }) => theme.color.black};
    border-radius: 1.5rem;
    span {
      font-weight: 700;
    }
    font-size: 1.6rem;
    line-height: 2.2rem;
    input {
      margin-right: 1.5rem;
      display: none;
    }
    label {
      cursor: pointer;
    }
  }
  .select {
    span {
      color: ${({ theme }) => theme.color.yellow};
    }
    color: ${({ theme }) => theme.color.white};
    background-color: ${({ theme }) => theme.color.purple_light};
    /* border: 1px solid ${({ theme }) => theme.color.purple_primary}; */
    box-shadow: 0px 3px 10px rgba(33, 23, 95, 0.15);
  }
`;
const ChangeText = styled.div`
  span {
    font-weight: 700;
  }
  font-size: 1.8rem;
  line-height: 2.2rem;
`;
